import {Injectable} from "@angular/core";
import {Observable, Subscriber} from "rxjs";
import {ConfigurationService} from "./configuration";
import {Receipt} from "../types/receipt";
import {Printer} from "../types/printer";
import {PrintServiceNets} from "./print.service.nets";
import {CardPaymentAndPrintServicePoplatek} from "./cardpayment.service.poplatek";

@Injectable()
export class PrintService implements Printer {

  currentStrategy: Printer;

  constructor(private conf: ConfigurationService,
              private nets: PrintServiceNets,
              private poplatek: CardPaymentAndPrintServicePoplatek) {
    this.checkStrategy();
  }

  public checkStrategy() {
    if (this.conf.isPoplatekWsPt()) {
      this.currentStrategy = this.poplatek;
    } else {
      this.currentStrategy = this.nets;
    }
  }

  print(receipt: Receipt): Observable<string> {
    return this.currentStrategy.print(receipt);
  }

  printSlip(activeReceipt: Receipt, copy?: boolean): Observable<string> {
    return this.currentStrategy.printSlip(activeReceipt, copy);
  }

}
